<template>
  <!--  sidebar-class="border-right border-danger"-->
  <!--       class="add-publishing" -->
  <b-sidebar
      :ref="sidebarId"
      :no-header="noHeader"
      :no-slide="noSlide"
      :id="sidebarId"
      :visible="sbModel"
      :width="width"
      :right="right"
      :backdrop="backdrop"
      :shadow="shadow"
      :lazy="lazy"
      :centered="centered"
      :no-close-on-backdrop="noCloseOnBackdrop"
      :backdrop-variant="backdropVariant"
      bg-variant="purple"
      sidebar-class="custom-class"
      @change="handleSidebarChange"
  >
    <b-card
        style="height:100vh;background-color: #8B41E5FF ;"
    >
      <b-alert
          variant="warning"
          dismissible
          :show="showWarning"
      >
        {{warningMsg}}
      </b-alert>
      <session-stage
          v-if="true"
          :profile="profile"
      />
      <b-card v-if="!production" class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </b-card>
    <template #footer>
      <div style="background-color: yellow">
      </div>
    </template>
    <div></div>
  </b-sidebar>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import SessionStage from "@/components/common/sessionComponents/sessions/sessionStandard";

import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import AudioRecorder from "@/components/blockResources/_components/audioRecorder";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import ToggleSingle from "@/components/blockResources/_components/toggleSingle";

export default {
  name: "Sessions_Sidebar",
  mixins: [UploadImage],
  components: {
    SessionStage,
    ImageUpload,
    Editor,
    AudioRecorder,
    VueBootstrapTypeahead,
    LabelInfo,
    ToggleSingle
  },
  props: {
    sidebarId: {
      type: String,
      required: true
    },
    session: {
      type: Object,
      required: ()=>{return {}}
    },
    profile: {
      type: Object,
      required: ()=>{return {}}
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    resource: {
      type: Object,
      required: ()=>{return {}}
    },
    settings: {
      type: Object,
      required: ()=>{return {}}
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
    assetsUrlHome: {
      type: String,
      default: "",
      required: false
    },
    updatedAt: {
      type: String,
      default: "",
      required: false
    }
  },
  created() {},
  mounted() {
    this.resetForm(); //@TODO do I need to deepclone ?
    //Time
    this.form._created_at = new Date();
    this.createdBy = this.form._created_by;
    this.createdBy.uid = this.profile.userId ? this.profile.userId : null;
    this.createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    this.createdBy.imgURL = this.profile.imgURL;


    //Check for any needs and give alert if necessary
    if (!this.localeInfo.isSet && false) {
      this.warningMsg="Please set your locale so that we can provide the correct calendar"
      this.showWarning = true;
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      apps: "user/apps",
      userData: "user/appsData"
    }),
    settings_hasEndDate() {
      return this.settings && this.settings.user
          ? this.settings.user._hasEndDate
          : true;
    },
    settings_hasTimeToTake() {
      return this.settings && this.settings.user
          ? this.settings.user._hasTimeToTake
          : true;
    },
    settings_hasPrescriptionInfo() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPrescriptionInfo
          : true;
    },
    settings_hasMedicationImage() {
      return this.settings && this.settings.user
          ? this.settings.user._hasMedicationImage
          : true;
    },
    settings_hasNotes() {
      return this.settings && this.settings.user
          ? this.settings.user._hasNotes
          : true;
    },
    settings_hasRefillReminders() {
      return this.settings && this.settings.user
          ? this.settings.user._hasRefillReminders
          : true;
    },
    settings_hasPharmacyInfo() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPharmacyInfo
          : true;
    },
    settings_hasDosageForm() {
      return this.settings && this.settings.user
          ? this.settings.user._hasDosageForm
          : true;
    },
    settings_hasNotification() {
      return this.settings && this.settings.user
          ? this.settings.user._hasNotification
          : true;
    },
    settings_hasPurpose() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPurpose
          : true;
    },
    settings_hasAllergies() {
      return this.settings && this.settings.user
          ? this.settings.user._hasAllergies
          : true;
    },
    settings_hasStorageInstructions() {
      return this.settings && this.settings.user
          ? this.settings.user._hasStorageInstructions
          : true;
    },
    settings_hasSideEffects() {
      return this.settings && this.settings.user
          ? this.settings.user._hasSideEffects
          : true;
    },
    settings_hasEmergencyContact() {
      return this.settings && this.settings.user
          ? this.settings.user._hasEmergencyContact
          : true;
    },
    settings_hasTags() {
      return this.settings && this.settings.user
          ? this.settings.user._hasTags
          : true;
    },
    settings_hasMedicationHistory() {
      return this.settings && this.settings.user
          ? this.settings.user._hasMedicationHistory
          : true;
    },
    /***TIME - move to top Level component */
    time() {
      return this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    milliseconds: function() {
      return this.currentTime;
    },
    hours: function() {
      var milli = this.milliseconds;
      // Doing the math
      // var hrs = Math.floor((milli / 3600000) % 24);
      // Using getHours()
      var hrs = new Date().getHours();
      if (hrs >= 13) {
        hrs = hrs - 12;
      }
      return hrs >= 10 ? hrs : "0" + hrs;
    },
    minutes() {
      var milli = this.milliseconds;
      var min = Math.floor((milli / 60000) % 60);
      return min >= 10 ? min : "0" + min;
    },
    seconds() {
      var milli = this.milliseconds;
      var sec = Math.ceil((milli % 60000) / 1000).toFixed(0);
      //if (sec == 60) { sec = 00 }
      return sec >= 10 ? sec : "0" + sec;
    },
    day() {
      return "TUESDAY";
    },
    timeOfDay() {
      return "morning";
    },
    date() {
      //Settings could ask o
      return moment(Date.now())().format("MM/DD/YYYY");
    },
    /**** Validations ****/
    state() {
      return true;
    },
    invalidFeedback() {
      if (false) {
        return "Enter at least 4 characters.";
      }
      return "Please enter something.";
    },
    /* USERDATA */
    titleDate() {
      //"dddd, MMMM DD  YYYY"
      return moment(new Date()).format("MMMM DD YYYY");
    },
  },
  methods: {
    handleMedicationTypeAheadClick(event){
      //$event => (medication = $event.text)
      debugger;
      //Bring in as much info as possible, e.g. notes
      this.form.medicationName = event.text;
      this.form.images.medicationImage.imgURL = event.imgURL
    },
    handleToggleClick() {
      this.form._isCurrentlyTaking = !this.form._isCurrentlyTaking;
    },
    /**/
    handleAudioRecordedInfoByCreatedBy(info){
      debugger;
      if(this.form && this.form.audio){
        this.form.audio = info;
      }
      this.form._added_audio_at = new Date();
    },
    handleAddDocToggle() {
      this.addDocument = !this.addDocument;
    },
    handleImgUploadedMedicationImgURL(idx, url) {
      debugger;
      if(this.form && this.form.images && this.form.images.medicationImage &&
          this.form.images.medicationImage) {
        this.form.images.medicationImage.imgURL = url;
        this.form.images.medicationImage._created_at = new Date();
        this.form.images.medicationImage._created_by = this.createdBy;
      }
    },
    handleImgUploadedMedicationLabelURL(idx,url) {
      if(this.form && this.form.images && this.form.images.medicationLabel &&
          this.form.images.medicationLabel) {
        this.form.images.medicationLabel.imgURL = url;
        this.form.images.medicationLabel._created_at = new Date();
        this.form.images.medicationLabel._created_by = this.createdBy;
      }
    },
    resetForm() {
      debugger;
      this.form = null;
      this.form = _.clone(this.defaultForm);
    },
    input(val) {
      this.form.note = val.content;
    },
    handleItemClick(item) {
      this.$emit("item-clicked", item);
    },
    handleSaveClick() {
      debugger;
      this.$emit("med-form-click", this.form);
      this.resetForm();
      this.handleCloseSideBar();
    },
    handleStartEndCallClick() {
      this.callStarted = !this.callStarted;
      if (this.callStarted) {
        this.form._started_at.push[Date.now()];
      } else {
        this.form._ended_at.push[Date.now()];
      }
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    resetClear() {
      this.clear = false;
    },
    handleCloseSideBar(){
      this.$root.$emit('bv::toggle::collapse', this.sidebarId);
    },
    handleSidebarChange(){

    },
  },
  data() {
    return {
      production: true,
      /** SIDEBAR PREF BEGIN **/
      noHeader:true,
      width:"100%",
      right: true,
      shadow: true,
      backdrop: true,
      backdropVariant: 'dark',
      noCloseOnBackdrop: false,
      lazy: false,
      centered: true,
      noSlide: true,
      bgVariant: 'warning',
      /** SIDEBAR PREF END **/
      createdBy: null,
      storagePath: "app_medication_images",
      assetURLPath:"/assets/apps/",
      localeInfo: this.profile && this.profile.about && this.profile.about.locale ?
          { locale: this.profile.about.locale, isSet: true } :
          {locale: "en-US", isSet: false},
      showWarning: false,
      warningMsg: "Please set your locale in settings > settings",
      callStarted: false,
      duration: 0,
      /*** TIME ***/
      timePolling: null,
      currentTime: Date.now(),
      changes: null,
      /*** TIME****/
      addDocument: false,
      idx: 0,
      docs: [],
      clear: false,
      form: {},
      defaultForm: {
        _created_at: null,
        _started_at: [],
        _ended_at: [],
        _isCurrentlyTaking: false,
        medicationName: "",
        dosage: "",
        frequency:"",
        _start_date_at:"",
        _end_date_at:"",
        timesToTake:[],
        prescriptionInfo:"",
        images:{
              medicationImage:{
                imgURL:"",
                _created_at:""
              },
          medicationLabel:{
            imgURL:"",
            _created_at:""
          },
        },
        notes:[],
        refillReminders:[],
        pharmacIbfo:{name:"",
               location:"",
                url:""
        },
        medicationCtegory:"",
        sideEffects:[],
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
        }
      },
      callPriorityOpt:[
        {
          "value": "urgent",
          "text": "Urgent",
          "color":"red",
          "_created_at": 1234
        },
        {
          "value": "high",
          "text": "High",
          "_created_at": 1234
        },
        {
          "value": "medium",
          "text": "Medium",
          "_created_at": 1234
        },
        {
          "value": "low",
          "text": "Low",
          "_created_at": 1234
        }
      ],
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.custom-class {
  color: var(--primary);
  background-color: var(--warning);
}
.toggle-button {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
